exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.tab-infor-button {\n  text-align: right;\n  margin-top: 20px;\n}\n.money-total {\n  padding: 5px;\n  background-color: #67c23a;\n  color: white;\n}\n", ""]);

// exports
